
import { computed, defineComponent, PropType } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { IUseDiscountInput } from '../composables/useDiscountInput'
import CDiscountInternalNameInput from './inputs/CDiscountInternalNameInput.vue'
import CDiscountPublicNameInput from './inputs/CDiscountPublicNameInput.vue'
import CDiscountReferenceInput from './inputs/CDiscountReferenceInput.vue'
import CStepSubGroup from './CStepSubGroup.vue'

export default defineComponent({
  name: 'CEditIdentificationInformation',
  components: { CStepSubGroup, CDiscountInternalNameInput, CDiscountPublicNameInput, CDiscountReferenceInput },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    reference: {
      type: Object as PropType<IUseDiscountInput>,
      required: true,
    },
    internalName: {
      type: Object as PropType<IUseDiscountInput>,
      required: true,
    },
    publicName: {
      type: Object as PropType<IUseDiscountInput>,
      required: true,
    },
    fromActive: {
      type: Boolean,
      default: true,
    },
    discountScope: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const i18n = useI18nForVue2()

    const message = computed(() =>
      props.fromActive ? null : i18n.t('ctx.discount.form.duplicate-reference-message').toString(),
    )

    return { message }
  },
})
